export default {"src":"/_next/static/media/Checklist.cb5df273.svg","height":306,"width":406};